import { createStyles, makeStyles } from '@material-ui/styles';
import themes from 'styles/themes';

export const useStyles = makeStyles(() =>
    createStyles({
        wrapper: {
            margin: 'auto',
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: 199,
        },
        main: {
            height: '100%',
        },
        padContainer: {
            height: 60,
            width: '100%',
        },
        contentPage: {
            backgroundColor: '#FFFFFF',
            padding: '0 24px 0 24px',
            borderRadius: '20px 20px 0px 0px',
            height: '100%',
        },
        itemsTitle: {
            width: '100%',
            position: 'relative',
            padding: '18px 10px 0 10px',
        },
        itemsTitleText: {
            width: '100%',
            fontSize: 18,
            fontWeight: 500,
            color: themes.palette.primary.main,
            fontFamily: 'PoppinsRegular',
            margin: 0,
            textAlign: 'center',
        },
        itemsTitleIcon: {
            position: 'absolute',
            top: 18,
            right: 10,
            color: '#4A6C72',
        },
        body: {
            paddingTop: 20,
        },
        contentTitle: {
            fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '32px',
            lineHeight: '38px',
            textAlign: 'center',
        },
        contentDescription: {
            marginTop: 20,
            fontFamily: 'PoppinsRegular',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '16px',
            lineHeight: '24px',
            textAlign: 'center',
            color: themes.palette.primary.main,
        },
        imageContainer: {
            paddingTop: 30,
        },
        image: {
            width: '100%',
        },
    }),
);
